import service from '@/service/service';
import api from '@/service/marketing/index';
import createStore from '@/store/base/create-store';
const { state, actions, mutations } = createStore(api);
import { getDmpPageInfo, getUrl } from '@/util/dmp';
import { getH5ConfiguratorLink } from '@/util/car.js';
import { DMP_LINK_TARGET_SUBTYPE, NEW_CAR_SERIES_LIST } from '@/config/enums';
const DEFAULT_CAR_MODEL = 'es7';

const tempState = {
    watermark: '',
    // 活动配置
    campaignOption: {
        accountId: '', // 邀请人accountId，无需加密
        userAccount: '', // 邀请人accountId，无需加密 兼容参数key
        carModel: DEFAULT_CAR_MODEL,
        inviterChannel: '', // 涟漪邀请channel
        uniqueKey: '', // url 参数 unique_key
        fellowEmpDomain: '', // 归属fellow域账号
        registerEmpDomain: '', // 留资fellow域帐号
        fellowId: '' // url参数
    },
    // 落地页配置
    pageConfig: {},
    // 落地页组件名称列表
    trackComponentNames: [],
    // 成功状态
    successStatus: 0,
    // 访问时间
    accessTime: new Date().getTime(),
    // 登录信息
    loginInfo: {},
    // 登录用户信息
    userProfile: {
        account_id: '',
        mobile: '',
        user_id: ''
    },
    // 敬请期待
    comingSoon: false,
    // 网络错误
    networkError: false,
    ...state
};

const tempMutations = {
    setPageConfig(state, data) {
        const { pageConfig, trackComponentNames } = getDmpPageInfo(data);
        // 引导页link组件/image组件配置爱车链接中车型参数受入参控制
        pageConfig.components.forEach(item => {
            if (['link', 'image'].includes(item.type)) {
                if (
                    item.props.targetConfig &&
                    item.props.targetConfig.targetSubType ===
                        DMP_LINK_TARGET_SUBTYPE.configcar
                ) {
                    item.props.href = getH5ConfiguratorLink(
                        (item.props.targetConfig.carType || 'es7').toLowerCase()
                    );
                }
                if (item.props.href) {
                    item.props.href = getUrl(item.props.href, {
                        lp_campaign_code: pageConfig.campaignSourceCode
                    });
                }
            }
        });
        state.pageConfig = pageConfig;
        state.trackComponentNames = trackComponentNames;
    },
    setCampaignOption(state, data) {
        const sourceData = data;
        if (sourceData.carModel) {
            sourceData.carType = sourceData.carModel;
        }
        state.campaignOption = _.merge(state.campaignOption, sourceData);
        if (state.campaignOption.userAccount) {
            state.campaignOption.accountId = state.campaignOption.userAccount;
        }
        if (state.campaignOption.inviterAccountId) {
            state.campaignOption.accountId =
                state.campaignOption.inviterAccountId;
        }
        if (state.campaignOption.carType) {
            state.pageConfig.presetModel = state.campaignOption.carType.toLowerCase();
        }
        if (state.campaignOption.fellow_id) {
            state.campaignOption.fellowId = state.campaignOption.fellow_id;
        }
        if (state.campaignOption.fellow_emp_domain) {
            state.campaignOption.fellowEmpDomain =
                state.campaignOption.fellow_emp_domain;
        }
        if (state.campaignOption.register_emp_domain) {
            state.campaignOption.registerEmpDomain =
                state.campaignOption.register_emp_domain;
        }
        if (state.campaignOption.campaign_code) {
            state.pageConfig.campaignSourceCode =
                state.campaignOption.campaign_code;
        }
        if (state.campaignOption.campaignCode) {
            state.pageConfig.campaignSourceCode =
                state.campaignOption.campaignCode;
        }
        if (state.campaignOption.campaignSourceCode) {
            state.pageConfig.campaignSourceCode =
                state.campaignOption.campaignSourceCode;
        }
    },
    setLoginInfo(state, data) {
        state.loginInfo = data || {};
    },
    setUserProfile(state, data) {
        state.userProfile = data || {};
    },
    setSuccessStatus(state, data) {
        state.successStatus = data;
    },
    setComingSoon(state, data) {
        state.comingSoon = data;
    },
    setNetworkError(state, data) {
        state.networkError = data;
    },
    ...mutations
};

const tempActions = {
    /**
     * 初始化
     */
    init({ dispatch, commit, state, rootState }, param) {
        const { host } = param;
        // 获取参数
        const combineParam = {
            ...param.query,
            ...param.params,
            host
        };
        if (param.query.mode) {
            state.watermark = param.query.mode;
        }
        // 获取落地页配置
        return dispatch('pageConfigInit', combineParam)
            .then(pageConfig => {
                const configMode =
                    { drive: 'testdrive', leads: 'leads' }[pageConfig.mode] ||
                    'leads';
                return Promise.all([
                    // 获取车辆配置
                    dispatch(
                        'configCarV2',
                        { mode: configMode, host },
                        { root: true }
                    )
                ]).then(() => {
                    // // 过期
                    // if (
                    //     state.campaignOption.expire_time &&
                    //     new Date().getTime() > state.campaignOption.expire_time
                    // ) {
                    //     commit('setPageConfig', { components: [] });
                    // }
                    // // 车型校验
                    // if (state.pageConfig.presetModel) {
                    //     const allowCarTypes = Object.keys(
                    //         rootState.configCarV2Data
                    //     );
                    //     const comingSoon =
                    //         NEW_CAR_SERIES_LIST.includes(
                    //             state.pageConfig.presetModel.toLowerCase()
                    //         ) &&
                    //         allowCarTypes.indexOf(
                    //             state.pageConfig.presetModel.toLowerCase()
                    //         ) < 0;
                    //     commit('setComingSoon', comingSoon);
                    // }
                    return state.pageConfig;
                });
            })
            .catch(e => {
                commit('setNetworkError', true);
                console.log(e);
            });
    },
    /**
     * 落地页配置初始化
     */
    pageConfigInit({ dispatch, commit, state }, param) {
        const { lpid, mode, host } = param;
        return dispatch('getLandPageConfig', {
            lpid,
            mode,
            host
        }).then(res => {
            // 解密统一参数
            if (res.result_code === 'success') {
                res.data.lpid = lpid;
                commit('setPageConfig', res.data);
            }
            return state.pageConfig;
        });
    },
    /**
     * 活动配置初始化 campaignOptionInit
     */
    campaignOptionInit({ dispatch, commit, state }, param) {
        const { fellow_id, campaign_code } = param;
        const { host, unique_key, uniqueKey, id } = param;

        commit('setCampaignOption', { fellow_id, campaign_code });

        const key = unique_key || uniqueKey || id;
        if (key) {
            commit('setCampaignOption', { uniqueKey: key });
            return dispatch('decodeUniqueKey', {
                key,
                host
            }).then(res => {
                // 解密统一参数
                try {
                    const data = JSON.parse(res.data);
                    commit('setCampaignOption', data);
                } catch (e) {
                    console.log('解析uniqueKey失败', e);
                }
                // 过期
                if (
                    state.campaignOption.expire_time &&
                    new Date().getTime() > state.campaignOption.expire_time
                ) {
                    commit('setPageConfig', { components: [] });
                }
                return state.campaignOption;
            });
        }
    },
    getWxConfigSig({ commit }, params) {
        const option = {
            ...api.wxConfigSig,
            data: params
        };
        return service(option, option.url).then(result => result);
    },
    ...actions
};

const store = {
    namespaced: true,
    strict: true,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations
};
export default store;



// WEBPACK FOOTER //
// ./src/store/marketing.js